"use client";
import { Button, Col, Flex, Row } from "antd";
import { IconArrowNarrowRight } from "@/lib/icons";
import AppImage from "../common/AppImage";
import Link from "next/link";
import styles from "./hero.module.css";
import ConvertedTime from "../convertedtime";

export default function Slide(props) {
  const bg = props.bg || "#021526";

  return (
    <Link href={props.href} prefetch>
      <div
        className={styles.heroContainer}
        style={{ background: bg, "--hero-bg": bg }}
      >
        <div className="flex flex-col md:flex-row w-full min-w-0">
          <div className="w-full md:w-1/2 order-2 md:order-1 min-w-0 flex flex-col justify-center">
            <Flex
              vertical
              justify="space-between"
              className={styles.heroContent}
              style={{ color: props.color }}
            >
              <span className={styles.title}>{props.title}</span>
              <div className="flex flex-wrap items-center justify-between sm:justify-start gap-2 sm:gap-6 w-full">
                <div
                  className={styles.eventName}
                  dangerouslySetInnerHTML={{ __html: props.event?.name || props.subheading }}
                />
                <div className={`${styles.datetime} shrink-0`}>
                  <ConvertedTime
                    time={props.start_time}
                    timezone={props.timezone}
                    date={props.start_date}
                  />
                  <span className="hidden sm:inline"><br /></span>
                  <span className="inline sm:hidden"> </span>
                  onwards
                </div>
                <Button
                  type="text"
                  shape="circle"
                  icon={<IconArrowNarrowRight size={20} />}
                  style={{
                    lineHeight: 1,
                    background: props.color,
                    color: bg,
                  }}
                  className="shrink-0"
                  aria-hidden="true"
                  tabIndex={-1}
                />
              </div>
            </Flex>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2 relative">
            <div className={`${styles.imgWrapper} bg-white/5`}>
              <div className={styles.gradient} />
              <AppImage
                src={props.image}
                alt={props.title || "Hero slide"}
                width={1000}
                height={500}
                priority={Boolean(props.isPriority)}
                loading={props.isPriority ? "eager" : "lazy"}
                sizes="(max-width: 768px) 95vw, 50vw"
                className="max-h-[295px] object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
